import { render, staticRenderFns } from "./caseClip_tagDetail.vue?vue&type=template&id=4b4b30ed&scoped=true"
import script from "./caseClip_tagDetail.vue?vue&type=script&lang=js"
export * from "./caseClip_tagDetail.vue?vue&type=script&lang=js"
import style0 from "./caseClip_tagDetail.vue?vue&type=style&index=0&id=4b4b30ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b30ed",
  null
  
)

export default component.exports